export const isEmpty = value =>
  value === undefined || value === "" || isNull(value) || value === "null";

export const isNull = value => typeof value === "object" && value === null;

export const hasOwnProperty = (obj, value) =>
  Object.prototype.hasOwnProperty.call(obj, value);

export const stylus = object => {
  let style = "";
  Object.keys(object).forEach(key => {
    style += `${key}: ${object[key]}px; `;
  });

  return style;
};

export const uniqueKey = () => {
  let keyMap = ["", "", ""];

  let uid = keyMap.map(() =>
    (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  );

  return uid.join("-");
};
